import { NavLink } from "react-router-dom";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "./ui/card";
import './LoginForm.css'
import { debugModeActive } from "../lib/utils";

export function SignupForm() {
    return (
        <div className="login-container">
            <Card className="login-card">
                <div className="login-image">
                    <img src="/assets/login-backgroud.png" alt="Login Background" />
                </div>
                <div className="card-white">
                    <CardHeader>
                        <CardTitle className="card-title">WellNuo</CardTitle>
                        <CardDescription className="card-desc">So you know they are well</CardDescription>
                    </CardHeader>
                    <CardContent>
                        <div className="text-center">
                            <p className="mb-2">At the moment user accounts are created automatically just after you purchase our devices. If you want to read more deatils please go to our <a href="https://www.wellnuo.com/" className="font-medium underline">website</a>.</p>
                            <NavLink to="/login"
                                className="text-blue-500 underline text-center hover:text-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500">
                                I have an account, login now!
                            </NavLink>
                        </div>
                    </CardContent>
                </div>
                {debugModeActive() && <p className="text-center text-gray-400 mt-1">Build Version: {process.env.REACT_APP_VERSION}</p>}
            </Card>
        </div>
    )
}